import { useState, useEffect, useRef } from 'react';
import { AppBar, Avatar, Box, Toolbar, styled } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import UserPopOver from './userPopover';
import styles from '../../../assets/styles/userHeader';
import '../../../assets/css/default.css';
import logo from '../../../assets/images/logo1.png';

const UserMenu = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	cursor: 'pointer',
	borderRadius: 24,
	padding: 4,
	'& span': { margin: '0 8px' },
	'span:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' },
}));

const Header = () => {
	const [open, setOpen] = useState(false);
	const [user, setUser] = useState(
		JSON.parse(decodeURIComponent(localStorage.getItem('profile')!))
	);
	const location = useLocation();
	const anchorRef = useRef(null);
	const classes = styles();

	const handlePopUp = () => {
		setOpen(false);
	};

	useEffect(() => {
		setUser(JSON.parse(decodeURIComponent(localStorage.getItem('profile')!)));
	}, [location]);

	return (
		<div>
			<AppBar position="fixed">
				<Toolbar className={classes.toolbar}>
					<img src={logo} alt="logo" width={50} />
					{user?.email ? (
						<Link className="customLinkStyle" to="/dashboard">
							{'B4Tax'}
						</Link>
					) : (
						<div className="customLinkStyle">B4Tax</div>
					)}
					<Box className={classes.boxContainer}>
						{user?.email ? (
							<>
								<UserMenu className="here">
									<div className={classes.avatarText}>{user?.fullName} </div>
									<Avatar
										onClick={() => setOpen(true)}
										ref={anchorRef}
										sizes="small"
										className={classes.avatar}
										sx={{ cursor: 'pointer' }}
									>
										{user?.email?.charAt(0).toUpperCase()}
									</Avatar>
								</UserMenu>
							</>
						) : (
							<Link to="/" className="customLinkheader">
								{'Sign In'}
							</Link>
						)}
					</Box>
				</Toolbar>
			</AppBar>
			{open ? (
				<UserPopOver
					anchorEl={anchorRef.current}
					open={open}
					onClose={handlePopUp}
				/>
			) : null}
		</div>
	);
};

export default Header;
